import React from "react";

import AppRouteGenerator from "components/Common/AppRouteGenerator";

import DataScience from "./DataScience";
import Datasets from "./Datasets";
import Reporting from "./Reporting";
import Tools from "./Tools";

const DataConsumption = ({ features }) => {
  const CLIENT_ROUTES = {
    Datasets: {
      component: Datasets,
      path: "datasets/*",
    },
    Reporting: {
      component: Reporting,
      path: "reporting/*",
    },
    "Data Science": {
      component: DataScience,
      path: "data-science/*",
    },
    Tools: {
      component: Tools,
      path: "tools/*",
    },
  };

  return (
    <AppRouteGenerator CLIENT_ROUTES={CLIENT_ROUTES} features={features} />
  );
};
export default DataConsumption;
